import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { first } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionInvoiceService {

    constructor(private http: HttpClient) {}

    createSubscriptionInvoice(data: any) {
        return this.http
          .post<any>(
            `${environment.url_api}/dashboard/subscription-invoices`,
            data,
          )
          .pipe(
            first(),
            // map((res: any) => res)
          );
    }

    updateSubscriptionInvoice(invoiceId: number, data: any) {
        return this.http
          .put<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}`,
            data,
          )
          .pipe(
            first(),
            // map((res: any) => res)
          );
    }
      
    paidInvoice(invoiceId: number) {
        return this.http
          .put<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}/paid`,
            {},
          )
          .pipe(
            first(),
            // map((res: any) => res)
          );
    }

    deleteSubscriptionInvoice(invoiceId: number) {
        return this.http
          .delete<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}`,
          )
          .pipe(
            first(),
            // map((res: any) => res)
          );
    }


}